import * as React from 'react';
import { Redirect } from 'react-router-dom';

import { RouterError } from '~src/app/spaces/RouterHelpers/RouterError';
import { Favorites } from '~src/content/resources/Favorites';
import { IPublishedConnectionDetailInfo } from '~src/ts/models/IPublishedConnectionInfo';

import { SpacesSiteUrls } from '../../app/spaces/SpacesSiteUrls';
import { PublishedConnections } from '../resources/PublishedConnections';

export interface PublishedConnectionSpaceFavoriteRedirectProps {
  readonly publishedConnectionId: string;
  readonly urls: SpacesSiteUrls;
}

type PublishedConnectionStatus = 'unfetched' | 'fetched' | 'error';

export const PublishedConnectionSpaceFavoriteRedirect: React.FunctionComponent<PublishedConnectionSpaceFavoriteRedirectProps> = props => {
  const [ publishedConnectionStatus, setPublishedConnectionStatus ] = React.useState<PublishedConnectionStatus>('unfetched');

  React.useEffect(
    () => {
      let didCancel = false;

      fetchPublishedConnection(props.publishedConnectionId)
        .then(() => !didCancel && setPublishedConnectionStatus('fetched'))
        .catch(() => {
          removeFavoritePublishedConnection(props.publishedConnectionId);
          !didCancel && setPublishedConnectionStatus('error');
        });

      return () => didCancel = true;
    },
    [props.publishedConnectionId]
  );

  if (publishedConnectionStatus === 'unfetched') {
    return null;
  } else if (publishedConnectionStatus === 'fetched') {
    return <Redirect to={props.urls.publishedConnectionPath(props.publishedConnectionId)}/>;
  } else {
    return <RouterError errorType={'publishedConnection-removed-favorite'} urls={props.urls} />;
  }
};

async function fetchPublishedConnection(publishedConnectionId: string): Promise<IPublishedConnectionDetailInfo> {
  return PublishedConnections.getById(publishedConnectionId);
}

function removeFavoritePublishedConnection(publishedConnectionId: string) {
  Favorites.remove(publishedConnectionId, 'publishedConnection');
}
